import * as React from "react";
import { isErrorState, QueryState } from "../utils/supabase/QueryState";
import { useGlobalAlertsSubject } from "../components/common/GlobalAlerts";
import { messages } from "../utils/i18n/i18n";
import { useTranslation } from "../utils/i18n/lang";

// TODO should be used in every useQuery?
export const useAlertOnQueryError = <Data,>(state: QueryState<Data>) => {
    const alerts$ = useGlobalAlertsSubject();
    const m = useTranslation(msg);

    React.useEffect(() => {
        if (isErrorState(state)) {
            console.error(state.kind, state.message);
            // sentry should already be triggered
            alerts$.next({
                severity: "error",
                message: m.queryFailed,
            });
        }
    }, [state.type]);
};

const msg = messages(
    {
        queryFailed: "Something went wrong, administrator has been notified",
    },
    {
        cs: {
            queryFailed: "Něco se pokazilo, administrátor byl informován.",
        },
    }
);
